import { useEffect, useState } from "react";

/**
 * Even though we attempt to auto-submit a transaction once a user has
 * authorized the transaction with PayPal, there is always a possibility that
 * the transaction does not go through because of something unexpected such as
 * a validation error. And in that case we need to make sure that if the
 * fundamental nature of the transaction changes the user needs to re-authorize
 * the new transaction with PayPal. An example of a meaningful change includes
 * any change to the amount or changing a transaction from a one-time
 * transaction to a recurring one.
 * @param {object} props
 * @param {boolean} props.hasCompletedPayPalAuthorizationFlow
 * @param {boolean} props.hasInitiatedPayPalAuthorizationFlow
 * @param {Function} props.handleResetPayPalAuthorizationFlow
 * @param {any[]} props.valuesThatShouldForceReauthorization
 * @returns {null}
 */
const UpdateShouldReauthorizePayPal = ({
    handleResetPayPalAuthorizationFlow,
    hasCompletedPayPalAuthorizationFlow,
    hasInitiatedPayPalAuthorizationFlow,
    valuesThatShouldForceReauthorization,
}) => {
    const [isInitialRender, setIsInitialRender] = useState(true);

    // Because this component should only be displayed after the user has
    // authorized a transaction we want to make sure we do not reset the PayPal
    // authorization flow every time it is displayed. Instead we want to wait
    // on a change to the list of values that should force a re-authorization.
    useEffect(() => {
        if (isInitialRender) {
            setIsInitialRender(false);
        } else if (
            hasInitiatedPayPalAuthorizationFlow ||
            hasCompletedPayPalAuthorizationFlow
        ) {
            handleResetPayPalAuthorizationFlow();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [...valuesThatShouldForceReauthorization]);

    return null;
};

export default UpdateShouldReauthorizePayPal;
